export default class PolicyTermPacket {
	public policyId: number | null = null;
	public termYear: number | null = null;
	public documentName: string | null = null;
	public documentUrl: string | null = null;

	public constructor() {

	}
}